export const VALID_ROLES = ['admin', 'manager', 'user']

const normalize = (value, allowedRoles = VALID_ROLES) => {
  if (value === null || value === undefined) return null
  const normalized = String(value).trim().toLowerCase()
  return allowedRoles.includes(normalized) ? normalized : null
}

export const normalizeOrgRole = (value) => normalize(value)
export const normalizeRole = (value) => normalize(value)

